import moment from 'jalali-moment';

export function _convertFaToEnCalendar(date: string) {
    // Date should be in this format: 1403/11/30
    return new Date(moment.utc(date, 'jYYYY/jMM/jDD').format('YYYY/MM/DD')).toISOString();
}

export function _convertFaToEnCalendar2(date: string) {
    return moment.from(date, 'fa', 'jYYYY/MM/DD').locale('en-EN').local().format('YYYY/MM/DD');
}
